export default {
    customContent: '',
    isFetching: false,
    hasError: false
};